import React from 'react';

interface ConsentInputProps {
  enabled: boolean;
  consentDate?: string;
  consentDateKey: string;
  consentCategories: string[];
  consentCategoriesKey: string;
}

const ConsentInput = ({
  enabled,
  consentDateKey,
  consentDate = '',
  consentCategoriesKey,
  consentCategories
}: ConsentInputProps) => {
  if (!enabled || !consentDate) {
    return null;
  }

  return (
    <div>
      <input type="hidden" value={consentDate} name={consentDateKey} />
      {consentCategories.map((category) => (
        <input key={category} type="hidden" value={category} name={consentCategoriesKey} />
      ))}
    </div>
  );
};

export default ConsentInput;
